export enum ActionVisibility {
    HIDDEN,
    VISIBLE
}
